import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { IAttachment } from '../models/attachments.model';
import { AttachmentService } from '../service/attachments.service';

@Component({
  selector: 'app-attachment-preview',
  templateUrl: './attachment-preview.component.html',
  styleUrls: ['./attachment-preview.component.scss'],
  standalone: false,
})
export class AttachmentPreviewComponent implements OnInit {
  loading = true;
  isPdf = false;
  link = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { attachment: IAttachment },
    private dialogRef: MatDialogRef<AttachmentPreviewComponent>
  ) {
    const isLocalhost = window.location.hostname === 'localhost';
    if (
      !isLocalhost &&
      !/^https?:\/\//i.test(this.data.attachment.link || '') &&
      !this.data.attachment.link?.includes(environment.apiUrl)
    ) {
      this.link = `${environment.apiUrl.replace('/api', '')}/${this.data.attachment.link}`;
    } else {
      this.link = this.data.attachment.link || '';
    }
  }

  ngOnInit() {
    this.isPdf = AttachmentService.resolveAttachmentType(this.data.attachment) === 'pdf';
  }

  close(): void {
    this.dialogRef.close();
  }
}
